<template>
  <div class="category-list-wrapper">
    <div class="loading-wrapper" v-if="loading">
      <LoadingWidget type="bar" ref="loading"></LoadingWidget>
    </div>

    <div v-else class="list-wrapper">
      <ListRow 
        v-for="category in categoryRows" 
        :key="category.id"
        :model="category">
      </ListRow>
    </div>
  </div>
</template>

<script>
//import ListCard from '@/components/lists/ListCard'
import ListRow from '@/components/lists/ListRow'
import LoadingWidget from '@Common/elements/LoadingWidget'
import { useCategorySetStore } from '@/stores/CategorySetStore'

export default {
  name: 'CategoryList',

  setup() {
    const categorySet = useCategorySetStore()
    return {
      categorySet
    }
  },

  props: {
  },

  data () {
    return {
      loading: true,
    }
  },

  computed: {
    categoryRows() {
      return this.categorySet.getSet.map(c => ({
        ...c,
        link: {
          name: 'category',
          params: { id: c.id },
        },
        cells: [
          {
            id: 'name',
            value: c.name,
            isLink: true,
          }
        ],
      }))
    },
  },

  methods: {
  },

  created() {
    this.categorySet.fetch().then(() => {
      this.loading = false
    })
  },

  components: {
    ListRow,
    LoadingWidget,
  }
}
</script>

<style lang="scss" scoped>
.category-list-wrapper {
  height: 100%;
  overflow: auto;
}
</style>
